var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.414 32.414"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Exit Icon",
    d: "M17.621 16.207L32.414 1.414 31 0 0 31l1.414 1.414 14.793-14.793L31 32.414 32.414 31zM12 13.414L.25 1.664 1.664.25 13.414 12z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "c13b517dd5e02af569141a35cfac48ea.svg";
export { SvgCrossIcon as ReactComponent };